module.exports = __webpack_public_path__ + "static/media/home-hero--bg-brazil.93cbd31d.jpg";